import * as React from 'react';
import styled from 'styled-components';
import YouTube, { YouTubeProps } from 'react-youtube';

type Props = {
  videoId: string;
  autoplay?: boolean;
};

const Root = styled(YouTube)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  background: ${({ theme }) => theme.backgroundColors.black};
  color: ${({ theme }) => theme.fontColors.white};
  border-radius: ${({ theme }) => theme.radii.m};
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const Videos: React.FC<Props> = (props) => {
  const opts: YouTubeProps['opts'] = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: props.autoplay ? 1 : 0,
      playlist: 'GmL0zU4-YyU,h1HphsdKBjU,TMOIXyj12ec',
      rel: 0,
      modestbranding: 1,
      playsinline: 0,
    },
  };

  return <Root videoId={props.videoId} opts={opts} />;
};
